import React, { useState } from "react";
import Logo from "./assets/logo.svg";
import ToggleIcon from "./assets/toggle-icon.svg";
import Closebtn from "./assets/close-btn.svg";
// import TwitterIcon from "./assets/logo-twitter.svg";
// import FbIcon from "./assets/logo-fb-simple.svg";
// import LinkdenIcon from "./assets/logo-linkden.svg";
// import GithubIcon from "./assets/logo-github.svg";

const HeaderNav = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleToggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Array of navigation links
  const navLinks = [
    { name: "Home", href: "/" },
    { name: "Why Obics", href: "/#why-obics" },
    { name: "Sandbox", href: "/sandbox-intro" },
    { name: "Contact", href: "/contact-us" },
    { name: "Blog", href: "/blog" },
    { name: "Docs", href: "/docs/intro" },
    { name: "Sign in", href: "https://app.obics.io" },
  ];

  return (
    <div className="z-40" id="header">
      <header className="max-w-[1200px] w-full mx-auto flex justify-between items-center gap-4">
        {/* Logo */}
        <a href="/">
          <img
            src={Logo}
            alt="Obics Logo"
            className="h-10 md:h-[50px] "
          />
        </a>

        {/* Desktop Navigation */}
        <ul className="hidden lg:flex items-center gap-[36px]">
          {navLinks.map((link, index) => (
            <li key={index}>
              <a
                href={link.href}
                className="text-light1 text-lg font-normal transition-all duration-300 hover:text-[#4558C1] hover:underline"
              >
                {link.name}
              </a>
            </li>
          ))}
          <li>
            <a
              href="/freetrial"
              className="btn-orange"
            >
              Free Trial
            </a>
          </li>
        </ul>

        {/* Toggle Button for Mobile Menu */}
        <button onClick={handleToggleMenu} className="inline-flex lg:hidden">
          <img src={ToggleIcon} alt="Toggle Menu" />
        </button>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="fixed top-0 left-0 w-full h-screen nav-section px-4 pt-5 pb-10">
            <div className="h-full flex flex-col justify-between">
              {/* Header Section in Mobile Menu */}
              <div className="flex items-center justify-between">
                <img
                  src={Logo}
                  alt="Obics Logo"
                  className="h-10 md:h-[50px] cursor-pointer"
                />
                <button onClick={handleToggleMenu}>
                  <img
                    src={Closebtn}
                    alt="Close Menu"
                    className="cursor-pointer"
                  />
                </button>
              </div>

              {/* Mobile Menu Links */}
              <ul className="flex items-center flex-col gap-[62px]">
                {navLinks.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.href}
                      className="text-light1 text-lg font-normal transition-all duration-300 hover:text-[#4558C1] hover:underline"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
              <a
                href="/freetrial"
                className="btn-orange"
              >
                Free Trial
              </a>

              {/* Footer Section with Social Icons */}
              {/* <div className="flex justify-center gap-6">
                <a
                  href="#"
                  className="h-8 w-8 rounded-full flex items-center justify-center border border-[#D4D4D8] hover:bg-orange1 hover:border-[#FF8039] transition-colors duration-300"
                >
                  <img src={TwitterIcon} alt="Twitter" />
                </a>

                <a
                  href="#"
                  className="h-8 w-8 rounded-full flex items-center justify-center border border-[#D4D4D8] hover:bg-orange1 hover:border-[#FF8039] transition-colors duration-300"
                >
                  <img src={FbIcon} alt="Facebook" />
                </a> */}

                {/* <a
                  href="#"
                  className="h-8 w-8 rounded-full flex items-center justify-center border border-[#D4D4D8] hover:bg-orange1 hover:border-[#FF8039] transition-colors duration-300"
                >
                  <img src={LinkdenIcon} alt="LinkedIn" />
                </a>

                <a
                  href="#"
                  className="h-8 w-8 rounded-full flex items-center justify-center border border-[#D4D4D8] hover:bg-orange1 hover:border-[#FF8039] transition-colors duration-300"
                >
                  <img src={GithubIcon} alt="GitHub" />
                </a> 
              </div>*/}
            </div>
          </div>
        )}
      </header>
    </div>
  );
};

export default HeaderNav;
